import { curry } from "fxjs/es";

export default curry((parent, child) => parent.appendChild(child));
